import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TwoFactorAuthenticationRegistrationFormType } from '../../two-factor-authentication-registration-form-type';

import { RouterLink } from '@angular/router';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordVisibilityDirective } from 'src/app/directives/password-visibility.directive';

export interface IStepAuthenticateData {
  header: string;
  description: string;
  linkLabel: string;
  linkRoute: string;
  buttonText: string;
}

@Component({
    selector: 'app-step-authenticate',
    templateUrl: './step-authenticate.component.html',
    styleUrls: ['./step-authenticate.component.scss'],
    imports: [RouterLink, AppErrorMessagesComponent, TranslateModule, ReactiveFormsModule, PasswordVisibilityDirective]
})
export class StepAuthenticateComponent implements OnInit {
  @Input() loading: boolean;
  @Input() data: IStepAuthenticateData;
  @Output() next = new EventEmitter<FormGroup<TwoFactorAuthenticationRegistrationFormType>>();

  public form: FormGroup<TwoFactorAuthenticationRegistrationFormType>;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  public onSubmit(): void {
    if (this.form.invalid || this.loading) {
      return;
    }
    this.next.emit(this.form);
  }

  private initializeForm(): void {
    this.form = this.fb.group<TwoFactorAuthenticationRegistrationFormType>({
      userName: this.fb.control(null, [Validators.required]),
      password: this.fb.control(null, [Validators.required])
    });
  }
}
